import React, { useState, useRef, useEffect } from "react";

const COLORS = {
    darkText: "#333",
    adjusted: "#e67e22",
    strikethrough: "#bbb",
    expense: "#ed578b",
    income: "#23d188",
};

function formatAmount(amount) {
    return Number(amount).toLocaleString("he-IL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function EditableAmount({ originalAmount, adjustedAmount, onConfirm, style, transactionType }) {
    const sign = transactionType === "expense" ? "-" : "+";
    const typeColor = transactionType === "expense" ? COLORS.expense : COLORS.income;
    const isAdjusted = adjustedAmount !== undefined && adjustedAmount !== originalAmount;
    const displayAmount = isAdjusted ? adjustedAmount : originalAmount;

    const [editing, setEditing] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const inputRef = useRef(null);

    useEffect(() => {
        if (editing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [editing]);

    const handleClick = () => {
        setInputValue(String(displayAmount));
        setEditing(true);
    };

    const handleConfirm = () => {
        setEditing(false);
        const newAmount = parseFloat(inputValue);
        if (isNaN(newAmount) || newAmount < 0) return;
        onConfirm(newAmount);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleConfirm();
        if (e.key === "Escape") setEditing(false);
    };

    if (editing) {
        return (
            <input
                ref={inputRef}
                type="number"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onBlur={handleConfirm}
                onKeyDown={handleKeyDown}
                style={{
                    width: "80px",
                    fontSize: "13px",
                    fontWeight: "bold",
                    padding: "2px 4px",
                    border: `1px solid ${COLORS.adjusted}`,
                    borderRadius: "4px",
                    outline: "none",
                    textAlign: "left",
                    direction: "ltr",
                    ...style,
                }}
            />
        );
    }

    if (isAdjusted) {
        return (
            <span
                onClick={handleClick}
                style={{ cursor: "pointer", ...style }}
                title="לחץ לעריכה"
            >
                <span style={{
                    textDecoration: "line-through",
                    color: COLORS.strikethrough,
                    fontSize: "11px",
                    marginLeft: "4px",
                }}>
                    {sign}{formatAmount(originalAmount)}
                </span>
                <span style={{
                    fontWeight: "bold",
                    color: COLORS.adjusted,
                    marginRight: "4px",
                }}>
                    {sign}{formatAmount(adjustedAmount)}₪
                </span>
            </span>
        );
    }

    return (
        <span
            onClick={handleClick}
            style={{
                cursor: "pointer",
                fontWeight: "bold",
                color: typeColor,
                ...style,
            }}
            title="לחץ לעריכה"
        >
            {sign}{formatAmount(originalAmount)}₪
        </span>
    );
}
